
                    (function() {
                        if (typeof document !== 'undefined') {
                            const existingLink = document.querySelector('link[data-esbuild="/css/survey.a8925411.css"]');
                            if (!existingLink) {
                                const link = document.createElement('link');
                                link.rel = 'stylesheet';
                                link.href = "/css/survey.a8925411.css";
                                link.setAttribute('data-esbuild', "/css/survey.a8925411.css");
                                document.head.appendChild(link);
                            }
                        }
                    })();
                    export default "/css/survey.a8925411.css";
                